module.exports = __webpack_public_path__ + "static/media/cc-light-circular.01a8782e.png";